export default [
  {
    // 预售列表
    path: '/presell/presell-index',
    name: 'presell-index',
    meta: {
      index: 1
    },
    component: () =>
      import(/* webpackChunkName: "presell-index" */ '@/pages/pre-sell/list.vue')
  },
  {
    // 预售订单
    path: '/presell/order',
    name: 'presell-index',
    meta: {
      index: 2
    },
    component: () =>
      import(/* webpackChunkName: "presell-index" */ '@/pages/pre-sell/pre-order/order.vue')
  },
  {
    // 订单详情
    path: '/presell/order/detail/:id',
    name: 'presell-index',
    meta: {
      index: 3
    },
    component: () =>
      import(/* webpackChunkName: "presell-index" */ '@/pages/pre-sell/pre-order/detail.vue')
  }
]
